/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostRecruitmentCreateMutationRequest, PostRecruitmentCreateMutationResponse, PostRecruitmentCreate400 } from '../entities/PostRecruitmentCreate'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postRecruitmentCreate } from '../api/postRecruitmentCreate'
import { useMutation } from '@tanstack/react-query'

export const postRecruitmentCreateMutationKey = () => [{ url: '/recruitment/create' }] as const

export type PostRecruitmentCreateMutationKey = ReturnType<typeof postRecruitmentCreateMutationKey>

/**
 * @description Вербовка водителя таксопарка
 * @summary Вербовка водителя таксопарка
 * {@link /recruitment/create}
 */
export function usePostRecruitmentCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostRecruitmentCreateMutationResponse,
      ResponseErrorConfig<PostRecruitmentCreate400>,
      { data: PostRecruitmentCreateMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<PostRecruitmentCreateMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postRecruitmentCreateMutationKey()

  return useMutation<
    PostRecruitmentCreateMutationResponse,
    ResponseErrorConfig<PostRecruitmentCreate400>,
    { data: PostRecruitmentCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postRecruitmentCreate(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}